import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {
  LoaderService, CfetBaseComponent, CfetPageNamesConstant, CfetService, CFETILMEndpointsConstant,
  CfetErrorMessagesConstant, ErrorService
} from '../../../cfet-core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-customer-profile-form',
    templateUrl: './customer-profile-form.component.html',
    styleUrls: ['./customer-profile-form.component.scss'],
    standalone: false
})
export class CustomerProfileFormComponent extends CfetBaseComponent implements OnInit {

  customerProfileFormGroup: UntypedFormGroup;
  securityCode: UntypedFormControl;
  securityCodeError: boolean;
  timeExpired: boolean;
  showSendCode = true;
  showCodeVerification = false;
  hideStaticText = false;
  checkOtpPage = true;
  openInactivityModal = '';
  countDownSession: any;
  showInactivityModal = true;
  showCompleteProfileSection = false;
  showCancelModal = false;
  openCancelModal = '';
  showLoading = false;
  updatedPersonalInfo: any;
  completeemailAddress: any;
  errorMessage: string;
  securityAnswer: any;
  securityQuestion: any;
  userPassword: any;
  timezone: any;
  selectedZipInWorkplace: any;
  selectedStateInWorkplace: any;
  selectedCity: any;
  addressLine2: any;
  addressLine1: any;
  requestToken: any;
  contactEmail: any;
  countDown: any;
  seconds: any;
  minutes: any;
  getPersonalInfo: any;
  useNumberInstead = false;
  useEmailInstead = true;
  displayUsedEmail = false;
  displayUsedNumber = true;
  showEmailSection = false;
  showNumberSection = true;
  emailAddress = '';
  wirelessNumber = '';
  @Output() showCompleteProfile: any = new EventEmitter<any>();

  constructor(private router: Router,
    private errorService: ErrorService,
    private loaderService: LoaderService,
    private cfetService: CfetService) { super(); }

  ngOnInit() {
    this.securityCode = new UntypedFormControl('', { validators: [Validators.required, Validators.minLength(6)] });
    this.customerProfileFormGroup = new UntypedFormGroup({
      securityCode: this.securityCode
    });

    if (sessionStorage.getItem('profileInformation') && Object.keys(sessionStorage.getItem('profileInformation')).length !== 0) {
      this.updatedPersonalInfo = JSON.parse(sessionStorage.getItem('profileInformation'));
      this.userPassword = this.updatedPersonalInfo.pwd;
      this.securityQuestion = this.updatedPersonalInfo.securityQuestion;
      this.securityAnswer = this.updatedPersonalInfo.securityAnswer;
      this.timezone = this.updatedPersonalInfo.timeZone;
    }
    if (environment.enableSessionTimeout && this.checkOtpPage) {
      this.checkInactivity();
    }
    if (sessionStorage.getItem('ngStorage-savedData') && Object.keys(sessionStorage.getItem('ngStorage-savedData')).length !== 0) {
      this.getPersonalInfo = JSON.parse(sessionStorage.getItem('ngStorage-savedData'));
      if (this.getPersonalInfo && this.getPersonalInfo.ctn && this.getPersonalInfo.emailaddress) {
        this.wirelessNumber = this.getPersonalInfo.ctn.slice(6, 10);
        this.completeemailAddress = this.getPersonalInfo.emailaddress;
        const tempEmail = this.getPersonalInfo.emailaddress.split('@');
        this.emailAddress = tempEmail[0].slice(tempEmail[0].length - 4, tempEmail[0].length) + '@' + tempEmail[1];
        this.addressLine1 = this.getPersonalInfo.address1;
        this.addressLine2 = this.getPersonalInfo.address2;
        this.selectedCity = this.getPersonalInfo.city;
        this.selectedStateInWorkplace = this.getPersonalInfo.state;
        this.selectedZipInWorkplace = this.getPersonalInfo.zipCode;
      }
    }
  }

  checkOTP() {
    if (this.securityCode.value === '' || this.securityCode.value !== undefined) {
      this.securityCodeError = false;
      this.timeExpired = false;
      this.errorService.showError.next(false);
    }
  }

  showEmail(event) {
    if (event.key === 'Enter' || event.type === 'click') {
      this.showEmailSection = true;
      this.showNumberSection = false;
    }
  }

  showNumber(event) {
    if (event.key === 'Enter' || event.type === 'click') {
      this.showEmailSection = false;
      this.showNumberSection = true;
    }
  }

  displayNumberOrEmailSection() {
    if (this.showNumberSection && !this.showEmailSection) {
      this.displayUsedNumber = true;
      this.displayUsedEmail = false;
      this.useEmailInstead = true;
      this.useNumberInstead = false;
    } else if (!this.showNumberSection && this.showEmailSection) {
      this.displayUsedNumber = false;
      this.displayUsedEmail = true;
      this.useEmailInstead = false;
      this.useNumberInstead = true;
    }
  }

  cancel(event) {
    this.setShowCancelModalToTrue(event);
  }

  manipulatingEmailAndSmsToRequestParam(requestParam) {
    if (!this.showNumberSection && this.showEmailSection) {
      requestParam['notification_method'] = 'email';
      requestParam['notification_value'] = this.getPersonalInfo.emailaddress.trim();
    } else if (this.showNumberSection && !this.showEmailSection) {
      requestParam['notification_method'] = 'sms';
      requestParam['notification_value'] = this.getPersonalInfo.ctn.replace(/\D/g, '');
    }
    return requestParam;
  }

  sendCode(event) {
    if (event.key === 'Enter' || event.type === 'click' && this.getPersonalInfo) {
      let requestParam = {
        'userid': this.getPersonalInfo.emailaddress.trim(),
        'company_id': 21,
        'notification_flow': 'actv',
        'verification_attributes': [
          {
            'attribute_name': 'sn',
            'attribute_value': this.getPersonalInfo.lastname
          }
        ]
      };
      requestParam = this.manipulatingEmailAndSmsToRequestParam(requestParam);
      this.cfetService.cfetLivePost(requestParam, CFETILMEndpointsConstant.VERIFY_IDENTITY_ACTIVATION).subscribe((response: any) => {
        if (response) {
          this.showLoading = false;
          this.displayNumberOrEmailSection();
          this.checkOtpPage = false;
          clearInterval(this.countDownSession);
          this.showCodeVerification = true;
          this.showSendCode = false;
          this.securityCode.reset();
          window.scrollTo(0, 0);
          this.minutes = '00';
          this.seconds = '00';
          if (response.otp_expire_time) {
            this.securityCodeError = false;
            this.timeExpired = false;
            this.timer(response.otp_expire_time);
          }
        }
      }, (_error) => {
        this.showLoading = false;
      });
    }
  }

  setNotificationMethodAndValueOfRequestParam(requestParam) {
    if (!this.showNumberSection && this.showEmailSection) {
      requestParam['notification_method'] = 'email';
      requestParam['notification_value'] = this.contactEmail;
    } else if (this.showNumberSection && !this.showEmailSection) {
      requestParam['notification_method'] = 'sms';
      requestParam['notification_value'] = this.getPersonalInfo.ctn.replace(/\D/g, '');
    }
    return requestParam;
  }

  resendCode(event) {
    if (event.key === 'Enter' || event.type === 'click') {
      this.securityCode.reset();
      clearInterval(this.countDown);
      // Hide the error component banner
      this.errorService.showError.next(false);
      this.securityCodeError = false;
      this.timeExpired = false;
      this.minutes = '00';
      this.seconds = '00';
      if (this.getPersonalInfo) {
        let requestParam = {
          'userid': this.getPersonalInfo.emailaddress.trim(),
          'company_id': 21,
          'verification_attributes': [
            {
              'attribute_name': 'sn',
              'attribute_value': this.getPersonalInfo.lastname
            }
          ],
          'notification_flow': 'actv',
          'request_token': this.requestToken
        };
        requestParam = this.setNotificationMethodAndValueOfRequestParam(requestParam);
        this.showLoading = true;
        this.cfetService.cfetLivePost(requestParam, CFETILMEndpointsConstant.VERIFY_IDENTITY_ACTIVATION).subscribe((response: any) => {
          if (response) {
            this.showLoading = false;
            this.minutes = '00';
            this.seconds = '00';
            if (response.otp_expire_time) {
              this.securityCodeError = false;
              this.timeExpired = false;
              this.timer(response.otp_expire_time);
            }
          }
        }, (_error) => {
          this.showLoading = false;
        });
      }
    }
  }

  useEmail(event) {
    if (event.key === 'Enter' || event.type === 'click') {
      this.showSendCode = true;
      this.showCodeVerification = false;
      this.checkOtpPage = true;
      this.showNumberSection = false;
      this.showEmailSection = true;
      this.securityCode.reset();
      // Hide the error component banner
      this.errorService.showError.next(false);
      this.securityCodeError = false;
      this.timeExpired = false;
      clearInterval(this.countDown);
    }
  }

  useNumber(event) {
    if (event.key === 'Enter' || event.type === 'click') {
      this.showSendCode = true;
      this.showCodeVerification = false;
      this.checkOtpPage = true;
      this.showNumberSection = true;
      this.showEmailSection = false;
      this.securityCode.reset();
      // Hide the error component banner
      this.errorService.showError.next(false);
      this.securityCodeError = false;
      this.timeExpired = false;
      clearInterval(this.countDown);
    }
  }

  disabledSubmitButton() {
    if (this.securityCode.value === null || this.securityCode.value === undefined) {
      return true;
    } else {
      return false;
    }
  }

  closeCancelModal(event) {
    if (event === 'modalClose') {
      this.openCancelModal = 'close';
    }
  }

  cancelSubmit(event) {
    this.setShowCancelModalToTrue(event);
  }

  timer(expire_minutes) {
    const countDownDate = expire_minutes === 5 ? new Date().getTime() + 300000 : new Date().getTime() + 1801000;
    this.countDown = setInterval(() => {
      const currentTime = new Date().getTime();
      const timeDiff = countDownDate - currentTime;
      this.seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
      this.minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      if (this.seconds < 10) {
        this.seconds = '0' + this.seconds;
      }
      if (this.minutes < 10) {
        this.minutes = '0' + this.minutes;
      }
      if (timeDiff < 0) {
        this.minutes = '00';
        this.seconds = '00';
        clearInterval(this.countDown);
        this.securityCodeError = false;
        this.timeExpired = true;
      }
    }, 350);
  }

  submit(event) {
    // send the user details to ILM for activating user profile
    if (event.key === 'Enter' || event.type === 'click') {
      this.showLoading = true;
      const requestParam = {
        'userid': this.completeemailAddress,
        'company_id': 21,
        'otp': this.securityCode.value,
        'password': this.userPassword,
        'profile': [
          {
            'attribute_name': 'tosFlag',
            'attribute_value': 'N'
          },
          {
            'attribute_name': 'Timezone',
            'attribute_value': this.timezone ? this.timezone : ''
          },
          {
            'attribute_name': 'SECURITY_QUESTION',
            'attribute_value': this.securityQuestion
          },
          {
            'attribute_name': 'SECURITY_ANSWER',
            'attribute_value': this.securityAnswer
          }
        ]
      };
      this.cfetService.cfetLivePost(requestParam, CFETILMEndpointsConstant.ACTIVATE_USER).subscribe((data: any) => {
        if (data && data.status && data.status.toLowerCase() === 'success') {
          const requestParam2 = {
            'company_id': environment.companyId,
            'userid': this.completeemailAddress,
            'notification_flow': 'epv',
            'notification_method': 'email',
            'notification_value': this.completeemailAddress
          };
          this.cfetService.cfetLivePost(requestParam2, CFETILMEndpointsConstant.USER_ACTIVATION_AUTHCODE_ILM).subscribe((res1: any) => {
            this.showLoading = false;
            this.showSendCode = false;
            this.showCodeVerification = false;
            this.checkOtpPage = false;
            clearInterval(this.countDownSession);
            // Redirect to complete page
            // this.showCompleteProfileSection = true;
            sessionStorage.clear();
            this.router.navigate([CfetPageNamesConstant.COMPLETE_PROFILE_CONFIRMATION]);
            // Hide the error component banner
            this.errorService.showError.next(false);
          }, (error) => {
            this.securityCodeError = false;
            this.errorMessage = error.error.message;
            this.errorService.displayErrorMessage(this.errorMessage);
            this.showLoading = false;
            window.scrollTo(0, 0);
          });
        }
      }, (error) => {
        // for weekPassword check & redirection to complete profile page
        if (error && error.error.errorcode && error.error.errorcode === 1020) {
          this.showSendCode = false;
          this.showCodeVerification = false;
          this.showCompleteProfileSection = false;
          this.showLoading = false;
          this.showCompleteProfile.emit(true);
          this.checkOtpPage = false;
          clearInterval(this.countDownSession);
          const fromOtpPage = {
            'action': 'fromOtpPage',
            'timeZone': this.timezone,
            'securityQuestion': this.securityQuestion,
            'securityAnswer': this.securityAnswer,
          };
          sessionStorage.setItem('fromOtpPage', JSON.stringify(fromOtpPage));
        } else {
          this.timeExpired = false;
          this.securityCodeError = true;
          this.errorMessage = CfetErrorMessagesConstant.CFET_CODE_INCORRECT_ERROR_MESSAGE;
          this.errorService.displayErrorMessage(this.errorMessage);
          this.showLoading = false;
          window.scrollTo(0, 0);
        }
      });
    }
  }
  
  closeInactivityModal(event) {
    if (event === 'modalClose') {
      this.openInactivityModal = 'close';
    }
  }

  @HostListener('window:load')
  @HostListener('document:mousemove')
  @HostListener('document:keyup')
  @HostListener('document:click')
  @HostListener('window:scroll')
  @HostListener('document:touchstart', ['$event']) onMove($event?: any) {
    if (environment.enableSessionTimeout && this.checkOtpPage) {
      clearInterval(this.countDownSession);
      this.checkInactivity();
    }
  }

  checkInactivity() {
    const countDownDate = new Date().getTime() + 120000;
    this.countDownSession = setInterval(() => {
      const currentTime = new Date().getTime();
      const timeDiff = countDownDate - currentTime;

      if (timeDiff < 30000) {
        this.openInactivityModal = 'open';
        this.showCancelModal = false;
      }
      if (timeDiff < 0) {
        clearInterval(this.countDownSession);
        this.openInactivityModal = 'close';
        sessionStorage.clear();
        window.location.href = CfetPageNamesConstant.SESSION_TIME_OUT;
      }
    }, 350);
  }

  setShowCancelModalToTrue(event: any) {
    if (event.key === 'Enter' || event.type === 'click') {
      this.showCancelModal = true;
      this.openCancelModal = 'open';
    }
  }
}
